/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
/** @jsxImportSource solid-js */

import { Component, createMemo, JSXElement, Show } from 'solid-js';
import Icon from '../Icon/Icon';

export interface EmptyProps {
  title?: string;
  message: string;
  icon: string;
  content?: JSXElement;
  isSmallContainer?: boolean;
  class?: string;
  backgroundTopColor?: string;
  backgroundBottomColor?: string;
  'data-testid'?: string;
}

const Empty: Component<EmptyProps> = (props) => {
  const getTitle = () => props.title;
  const getMessage = () => props.message;
  const getIcon = () => props.icon;
  const getContent = () => props.content;
  const getIsSmallContainer = () => props.isSmallContainer;

  const backgroundStyle = createMemo(() => {
    const topColor = props.backgroundTopColor;
    const bottomColor = props.backgroundBottomColor;
    if (topColor && bottomColor) {
      return {
        background: `linear-gradient(to bottom, ${topColor}, ${bottomColor})`,
      };
    }
    if (topColor) {
      return { background: topColor };
    }
    return undefined;
  });

  const getEmptyClass = () => {
    return `empty bg-gray_light ${getIsSmallContainer() ? 'small' : ''}`;
  };

  return (
    <div
      class={`${getEmptyClass()} ${props.class || ''} mw-100`.trim()}
      style={backgroundStyle()}
      data-testid={props['data-testid']}
    >
      <Show when={getIcon()}>
        <div
          class="flex items-center justify-center text-trimble_gray"
          style={{ width: '3rem', height: '3rem', opacity: '0.3' }}
        >
          <Icon icon={getIcon()} size="icon-xlarge" />
        </div>
        <div class="empty-text mt-2">
          <Show when={getTitle()}>
            <h3 class="text-muted">{getTitle()}</h3>
          </Show>
          <p class="small text-muted">{getMessage()}</p>
        </div>
      </Show>
      <Show when={getContent()}>
        {/* eslint-disable-next-line custom/no-direct-solid-component-invocation -- Tracked by https://jira.trimble.tools/browse/TWENG-38 */}
        <div class="empty-action">{getContent()}</div>
      </Show>
    </div>
  );
};

export default Empty;
